import steelGif from './../assets/images/steel-gif.gif'
import greedIsGoodJpg from './../assets/images/greedIsGood.jpg'
import evercatchPng from './../assets/images/evercatch.png'
import cartPng from './../assets/images/cart.png'
import brochurePng from './../assets/images/brochure.png'


const data = [
  {
    title: 'Steel Cavalry',
    preview: 'https://itch.io/queue/c/188585/gamkedo-club?game_id=243394',
    description: `First game I contributed as part of the the Gamkedo club`,
    image: steelGif,
    repo: `https://github.com/gamkedo-la/steelcavalry`
  },
  {
    title: 'GreedIsGood',
    preview: 'https://www.dropbox.com/s/jgskamlq297cx4h/greedIsGood.zip?dl=0',
    description: ` First attempt at making a Unity Game during college. Simple refelx based arcade game.`,
    image: greedIsGoodJpg,
  },
  {
    title: 'Evercatch',
    preview: 'http://ascendedalpaca.itch.io/evercatch',
    description: ` Game created in about 2-3 hours total for the 2014 SpeccyJam, creating a game restricted to the styling and ability of the ZX Spectrum.`,
    image: evercatchPng,
  },
]

export default data